import { sendUserOperation, SmartAccount } from "viem/account-abstraction";
import { ConnectedClient } from "./common";
import { getAction } from "viem/utils";
import { contract } from "./contract";
import { NavigateFunction } from "react-router-dom";
import { stash, tables } from "./stash";

export async function openArena(client: ConnectedClient, navigate?: NavigateFunction) {
  await getAction(
    client,
    sendUserOperation,
    "sendUserOperation",
  )({
    calls: [
      {
        to: contract.address,
        abi: contract.abi,
        functionName: "createMatch",
        args: ["", ""],
      },
    ],
    account: client.account! as SmartAccount,
    // TODO: optimize gas limits
    maxFeePerGas: 10_000n,
    maxPriorityFeePerGas: 1n,
    verificationGasLimit: 1_000_000n,
    preVerificationGas: 100_000n,
    callGasLimit: 1_000_000n,
    paymasterPostOpGasLimit: 100_000n,
    paymasterVerificationGasLimit: 100_000n,
  });
  const unsubscribe = stash.subscribeTable({
    table: tables.Match,
    subscriber: (update) => {
      const match = Object.values(update)[0].current;
      if (match?.players.includes(client.account!.address)) {
        unsubscribe();
        navigate?.("/arena");
      }
    },
  });
}

export async function enterArena(client: ConnectedClient, navigate?: NavigateFunction) {
  await getAction(
    client,
    sendUserOperation,
    "sendUserOperation",
  )({
    calls: [
      {
        to: contract.address,
        abi: contract.abi,
        functionName: "joinCurrentMatch",
        args: [],
      },
    ],
    account: client.account! as SmartAccount,
    // TODO: optimize gas limits
    maxFeePerGas: 10_000n,
    maxPriorityFeePerGas: 1n,
    verificationGasLimit: 1_000_000n,
    preVerificationGas: 100_000n,
    callGasLimit: 1_000_000n,
    paymasterPostOpGasLimit: 100_000n,
    paymasterVerificationGasLimit: 100_000n,
  });
  const unsubscribe = stash.subscribeTable({
    table: tables.Match,
    subscriber: (update) => {
      const match = Object.values(update)[0].current;
      if (match?.players.includes(client.account!.address)) {
        unsubscribe();
        navigate?.("/arena");
      }
    },
  });
}
